import { Button } from '../ui/button';

export function AdminDiscountsTab({ discounts, onToggleDiscount }) {
  return (
    <div className="card-surface overflow-hidden">
      {discounts.length === 0 ? (
        <p className="text-stone-400 text-center py-12">No discount codes</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-[#F9F6F0]">
              <tr>
                <th className="text-left py-3 px-4 text-stone-600 font-medium text-sm">Code</th>
                <th className="text-left py-3 px-4 text-stone-600 font-medium text-sm">Provider</th>
                <th className="text-left py-3 px-4 text-stone-600 font-medium text-sm">Type</th>
                <th className="text-left py-3 px-4 text-stone-600 font-medium text-sm">Value</th>
                <th className="text-left py-3 px-4 text-stone-600 font-medium text-sm">Usage</th>
                <th className="text-left py-3 px-4 text-stone-600 font-medium text-sm">Active</th>
                <th className="text-left py-3 px-4 text-stone-600 font-medium text-sm">Actions</th>
              </tr>
            </thead>
            <tbody>
              {discounts.map(d => (
                <tr key={d.discount_id} className="border-b border-[#E6E4DD] hover:bg-[#F9F6F0]">
                  <td className="py-3 px-4 font-mono text-sm font-semibold text-[#1A1A1A]">{d.code}</td>
                  <td className="py-3 px-4 text-sm text-stone-600">{d.provider_name}</td>
                  <td className="py-3 px-4 text-sm text-stone-500 capitalize">{d.discount_type?.replace('_', ' ')}</td>
                  <td className="py-3 px-4 text-sm font-medium">{d.discount_type === 'fixed' ? `£${d.value}` : `${d.value}%`}</td>
                  <td className="py-3 px-4 text-sm text-stone-500">{d.times_used || 0}{d.max_uses ? `/${d.max_uses}` : ''}</td>
                  <td className="py-3 px-4">
                    <span className={`text-xs font-medium ${d.is_active ? 'text-green-600' : 'text-red-500'}`}>{d.is_active ? 'Active' : 'Disabled'}</span>
                  </td>
                  <td className="py-3 px-4">
                    <Button size="sm" variant="ghost" onClick={() => onToggleDiscount(d.discount_id)} className={`h-8 px-2 text-sm ${d.is_active ? 'text-red-500' : 'text-green-600'}`} data-testid={`toggle-discount-admin-${d.discount_id}`}>
                      {d.is_active ? 'Disable' : 'Enable'}
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
